export const changeVisualizationContext = cash => ({
  type: 'ONLY_CASH',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'post',
      url: `/v1/participants/VisualizationContext`,
      data: {
        VisualizationContext: cash
      }
    }
  }
})

export const getVisualizationContext = () => ({
  type: 'PARTICIPANT_VISUALIZATION_CONTEXT',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: `/v1/participants/VisualizationContext`
    }
  }
})



// WEBPACK FOOTER //
// ./src/App/MainMenu/OnlyCash/actions.js